var map = {
	"./CityCentre.jpg": 7599,
	"./ElectricBoilerID.jpg": 6176,
	"./RadiatorID.jpg": 4926,
	"./Suburb_0.jpg": 999,
	"./Suburb_1.jpg": 9240,
	"./Suburb_2.jpg": 3245,
	"./Suburb_3.jpg": 1508,
	"./Suburb_4.jpg": 3961,
	"./SupplementalDistrictHeatingID.jpg": 3533,
	"./UnderfloorHeatingID.jpg": 7487,
	"./aldre_flerbostadshus.jpg": 1751,
	"./aldre_kontor.jpg": 7868,
	"./aldre_villa.jpg": 8820,
	"./ny_flerbostadshus.jpg": 2059,
	"./ny_kontor.jpg": 6127,
	"./ny_villa.jpg": 7923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7130;